import { render, staticRenderFns } from "./OrganizationSize.vue?vue&type=template&id=4f2a4a32&"
import script from "./OrganizationSize.vue?vue&type=script&lang=js&"
export * from "./OrganizationSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports